<app-page-header useInlineHeader="true">
    {{ 'Add New Community' }}
    <a mat-icon-button disableRipple
       [attr.aria-label]="routerBackButton.ariaLabel"
       [routerLink]="routerBackButton.route">
        <mat-icon>arrow_back</mat-icon>
    </a>
</app-page-header>

<form [formGroup]="formGroup">
    <app-details-card-container animated delayed [fadeFrom]="'bottom'">
        <mat-card>
            <mat-card-title>{{ 'Community Information' }}</mat-card-title>

            <mat-progress-bar mode="query" color="primary" [class.active]="savingOrganization"></mat-progress-bar>

            <mat-divider></mat-divider>

            <mat-card-content>
                <div class="form-group">
                    <label for="communityName" requiredMarker>{{ 'Community name' }}</label>
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                        <input id="communityName"
                               type="text"
                               formControlName="name"
                               matInput
                               [placeholder]="'Your new community name'"
                               [attr.aria-label]="'Your new community name'">
                    </mat-form-field>
                    <lf-control-messages [control]="formGroup.get('name')" [prefix]="'Community name'"></lf-control-messages>
                </div>

                <div *ngIf="canCopyResources" class="form-group" animated>
                    <label id="copyResourcesToggleControl">{{ 'Would you like to copy data from another community in your portfolio?' }}</label>
                    <mat-radio-group color="primary"
                                     formControlName="copyResources"
                                     [attr.aria-labelledby]="'copyResourcesToggleControl'">
                        <mat-radio-button [value]="true" disableRipple>{{ 'Yes' }}</mat-radio-button>
                        <mat-radio-button [value]="false" disableRipple>{{ 'No' }}</mat-radio-button>
                    </mat-radio-group>
                </div>

                <div *ngIf="formGroup.get('copyResources').value" nestedCardChecklist>
                    <label>{{ 'Select types of data to copy:' }}</label>
                    <ng-container formArrayName="copiedResources">
                        <mat-card *ngFor="let resource of copiedResources.controls; let i = index" [formGroupName]="i" nestedCard animated>
                            <mat-card-title><mat-checkbox formControlName="selected" disableRipple>{{ resource.get('label').value }}</mat-checkbox></mat-card-title>
                            <mat-card-content *ngIf="resource.get('selected').value">
                                <div class="form-group">
                                    <label>{{ 'Select a community to copy data from:' }}</label>
                                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                        <mat-select [panelClass]="'v2-panel'" placeholder="{{ 'Select Community' }}" formControlName="copySrc">
                                            <mat-option *ngFor="let org of (orgs$ | async)" [value]="org.id">{{ org.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </ng-container>
                </div>
            </mat-card-content>
        </mat-card>
    </app-details-card-container>

    <app-details-card-container animated delayed [fadeFrom]="'bottom'">
        <mat-card withFooter>
            <mat-card-title>{{ 'Community Manager(s)' }}</mat-card-title>

            <mat-divider></mat-divider>

            <mat-card-content>
                <div *ngFor="let admin of admins.controls; let i = index" class="form-group">
                    <mat-slide-toggle color="primary" disableRipple [class.hidden]="admin.get('isEditing').value" [formControl]="admins.at(i).controls.isSelected">
                        <app-avatar-block [initials]="initials(admin.get('fullName').value)">
                            <span avatarTitle withEdit="true">
                                {{ admin.get('fullName').value }}
                                <button *ngIf="!admin.get('id').value"
                                        mat-icon-button linkButton disableRipple
                                        (click)="admin.get('isEditing').setValue(true)">
                                    <mat-icon [svgIcon]="'v2:fi-br-edit'"></mat-icon>
                                </button>
                            </span>
                            <span avatarDescription>
                                <span [innerHTML]="admin.get('role').value === 'pmcUser' ? 'Property Manager' : 'Community Manager'"></span>
                                <span [innerHTML]="' • ' + (admin.get('organizations').value?.length | i18nPlural: organizationsMapping)"></span>
                            </span>
                            <span avatarDescription>
                                <span [innerHTML]="admin.get('email').value"></span>
                                <span [innerHTML]="admin.get('phone').value ? ' • ' + (admin.get('phone').value | legfiPhone) : ''"></span>
                            </span>
                        </app-avatar-block>
                    </mat-slide-toggle>
                </div>

                <app-team-member-add-card [formGroup]="formGroup">
                    <app-team-member-search (teamMembersLoaded)="teamMemberLoaded($event)" (teamMemberSelected)="teamMemberSelected($event)"></app-team-member-search>
                    <lf-control-messages [control]="admins" [prefix]="'At least once team member'"></lf-control-messages>
                    <button-spacer></button-spacer>
                </app-team-member-add-card>
            </mat-card-content>

            <mat-card-footer>
                <p><mat-icon [svgIcon]="'v2:fi-br-user'"></mat-icon>{{ admins.value.length | i18nPlural: managersMapping }}</p>
            </mat-card-footer>
        </mat-card>
    </app-details-card-container>

    <app-details-card-container animated delayed [fadeFrom]="'bottom'">
        <mat-card *ngIf="environment.production">
            <mat-card-content>
                <re-captcha [siteKey]="environment.RecaptchaSiteKey" (resolved)="resolved($event)"></re-captcha>
                <lf-control-messages [control]="formGroup.get('captchaToken')" [prefix]="'reCaptcha'"></lf-control-messages>
            </mat-card-content>
        </mat-card>

        <mat-toolbar>
            <a mat-flat-button disableRipple color="accent"
               [attr.aria-label]="'Cancel add community'"
               [routerLink]="routerBackButton.route"
               [queryParams]="routerBackButton.queryParams">
                {{ 'Cancel' }}
            </a>

            <flex-spacer></flex-spacer>

            <button mat-flat-button disableRipple color="primary" [disabled]="savingOrganization" (click)="submit()">
                {{ 'Save and Continue Setup' }}
            </button>
        </mat-toolbar>
    </app-details-card-container>
</form>
